// Onboarding (ADR-0104): lista "Configure sua empresa" e o tour de cada pessoa.
// A lista é calculada no servidor pelo dado real da empresa da sessão.

export const PERMISSAO_CONFIGURAR_EMPRESA = "empresa:configurar";

export async function lerEstadoOnboarding(request, { produto = "erp" } = {}) {
  return request(`/api/onboarding/estado?produto=${produto}`, { silentError: true });
}

// As duas escritas tratam o erro na própria tela (silentError) e devolvem o
// estado novo da lista inteira — a tela troca o que mostra sem outro GET.
export async function dispensarItem(request, item, motivo) {
  return request("/api/onboarding/dispensas", {
    method: "POST",
    body: JSON.stringify({ item, motivo }),
    silentError: true,
  });
}

export async function desfazerDispensa(request, item) {
  return request(`/api/onboarding/dispensas/${encodeURIComponent(item)}`, {
    method: "DELETE",
    silentError: true,
  });
}

export async function gravarTour(request, { desfecho, versao }) {
  return request("/api/onboarding/tour", {
    method: "POST",
    body: JSON.stringify({ desfecho, versao }),
    silentError: true,
  });
}
